module.exports = __webpack_public_path__ + "static/dp-logo-small-black-fc452ec7e4ebf8874f61b9a410c051d7.svg";